export default (amount: number, currency: string) =>
  Intl.NumberFormat("es", { style: "currency", currency: currency, currencyDisplay: "narrowSymbol" }).format(amount);

export const getSymbolFromCurrencyCode = (currency: string) =>
  Intl.NumberFormat("es", { style: "currency", currency: currency, currencyDisplay: "narrowSymbol" }).formatToParts(1);
